
export default function Footer() {
  return (
    <div className="Footer">
      <footer className="footer-section">
    <div className="section-padding footer">
      <div className="container-default w-container">
        <div className="footer-wrp">
          <div className="small-text letter-spacing-small">© 2026 Shopik
          </div>
          <div className="footer-links-wrp" hidden>
            <a href="/team" className="white-footer-link">Team</a>
          </div>
          <div className="footer-links-wrp" hidden>
            <a href="/blog" className="white-footer-link">Blog</a>
          </div>
          <div className="footer-links-wrp">
            <a href="/licenses" className="white-footer-link">Licenses</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
    </div>
  );
}
